export { default } from './BrandsList'
